<template>
  <HomeSectionWrapper
    bg="bg-white"
    :description="$t('vision.main_desc')"
    :title="$t('vision.badge')"
  >
    <div>
      <div class="w-full md:mt-5 lg:mt-14 mt-3 md:mx-auto sm:pb-0 pb-8">
        <div class="flex flex-wrap justify-center gap-3 md:gap-5 xl:gap-10">
          <div
            v-for="feature in features"
            :key="feature.title"
            class="space-y-4 flex flex-col items-center md:w-sm w-full border border-gray-300 rounded-lg lg:p-8 sm:p-5 p-3"
          >
            <div
              class="rounded-lg size-14 min-w-14 flex items-center justify-center bg-primary text-white"
            >
              <Icon :name="feature.icon" size="25" />
            </div>
            <h3 class="sm:text-2xl text-center text-lg font-bold text-primary">
              {{ $t(`${feature.title}`) }}
            </h3>
            <p class="md:text-base text-sm text-center text-gray-500">
              {{ $t(`${feature.description}`) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </HomeSectionWrapper>
</template>

<script setup lang="ts">
interface FeatureItem {
  title: string;
  description: string;
  icon: string;
}

const features = ref<FeatureItem[]>([
  {
    title: "vision.discover_title",
    description: "vision.discover_desc",
    icon: "ph:compass",
  },
  {
    title: "vision.empower_title",
    description: "vision.empower_desc",
    icon: "ph:lightbulb",
  },
  {
    title: "vision.connect_title",
    description: "vision.connect_desc",
    icon: "ph:link",
  },
  {
    title: "vision.journey_title",
    description: "vision.journey_desc",
    icon: "ph:map-trifold",
  },
]);
</script>
